import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Spin } from "antd";
import { Typography } from "antd/lib";
import { ReactElement, useState } from "react";
import { ruleRequired } from "../../../constants/rules/RulesConstantsForms";
import { useAppDispatch } from "../../../store/reduxHooks";
import { PASSWORD_RECOVERY_MAIL } from "../../../store/slice/authSliceLogin/authSliceLogin";

import classes from "./RecoveryPasswordForm.module.css";

const { Text } = Typography;

interface FieldType {
  email: string;
}

export function RecoveryPasswordForm(): ReactElement {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [isSendingQuery, setIsSendingQuery] = useState(false);

  async function onFinish(value: FieldType) {
    setIsSendingQuery(true);
    await dispatch(PASSWORD_RECOVERY_MAIL(value.email));
    setIsSendingQuery(false);
  }

  const textSubmitBtn = isSendingQuery ? (
    <Spin
      indicator={<LoadingOutlined className="loader-white" spin />}
      size="small"
    />
  ) : (
    "Восстановить пароль"
  );

  return (
    <Form
      form={form}
      layout="vertical"
      name="RECOVERY_PASSWORD"
      onFinish={onFinish}
    >
      <Text className={classes.recoveryPassInputLabel}>Email</Text>
      <Form.Item
        className={classes.recoveryPassEmailItem}
        rules={[ruleRequired, { type: "email", message: "Некорректный email" }]}
        layout="vertical"
        name="email"
      >
        <Input size="large" variant="filled" />
      </Form.Item>

      <Form.Item layout="vertical" className={classes.recoveryPasswordFormItem}>
        <Button
          size="large"
          style={{ width: "100%" }}
          htmlType="submit"
          disabled={isSendingQuery}
          color="primary"
          variant="solid"
          className={classes.recoveryPasswordSubmitBtn}
        >
          {textSubmitBtn}
        </Button>
      </Form.Item>
    </Form>
  );
}
